<template>
  <base-alert
    v-if="isInactive"
    type="warning"
    icon="fas fa-exclamation-triangle"
    class="mb-4"
  >
    <span class="alert-icon"><i class="fas fa-exclamation-triangle"></i></span>
    <span class="alert-text ml-2">
      <strong>{{ $t("ESTABLISHMENTS.ESTABLISHMENT_DEACTIVATED") }}</strong>
      {{ $t("ESTABLISHMENTS.ESTABLISHMENT_INACTIVE_ALERT") }}
    </span>
  </base-alert>
</template>

<script>
import BaseAlert from "@/components/BaseAlert.vue";

export default {
  name: "establishment-inactive-alert",

  components: {
    BaseAlert,
  },

  props: {
    establishment: {
      type: Object,
      default: null,
      description: "The establishment whose active state drives the alert",
    },
  },

  computed: {
    isInactive() {
      return !!(this.establishment && this.establishment.active === false);
    },
  },
};
</script>
